(() => {
  if (window.wwProductTermsPlacement) return;
  window.wwProductTermsPlacement = true;
  let queued = false;

  const place = () => {
    queued = false;
    const holders = [...document.querySelectorAll('.ww-product-terms')];
    holders.forEach((holder) => {
      if (holder.querySelector('.rale-widget')) holder.classList.remove('rale-shortcode');
    });

    const mainCheckbox = holders
      .map((holder) => holder.querySelector('.rale-widget input[type="checkbox"]'))
      .find(Boolean);
    const checkboxes = [...document.querySelectorAll('.rale-widget .rale-checkbox input[type="checkbox"]')];
    if (mainCheckbox && checkboxes.some((input) => input.checked) && checkboxes.some((input) => !input.checked)) {
      mainCheckbox.checked = false;
      mainCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (holders.some((holder) => holder.classList.contains('rale-shortcode') && !holder.querySelector('.rale-widget'))) {
      const legal = window.roarJs?.Legal;
      if (typeof legal?.refresh === 'function') legal.refresh();
    }
  };

  const schedule = () => {
    if (queued) return;
    queued = true;
    queueMicrotask(place);
  };

  document.addEventListener('rale.widgetCreated', schedule);
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver((records) => {
    const relevant = records.some((record) =>
      [...record.addedNodes].some((node) =>
        node.nodeType === 1 &&
        (node.matches('.ww-product-terms, .rale-widget') || node.querySelector('.ww-product-terms, .rale-widget'))
      )
    );
    if (relevant) schedule();
  }).observe(document.documentElement, { childList: true, subtree: true });

  schedule();
})();

